import { Link } from "react-router-dom";
import { navLinks, socialLinks, contactInfo } from "@/mocks/site";

const serviceLinks = [
  { name: "影视制作", path: "/services#production" },
  { name: "节目策划", path: "/services#programming" },
  { name: "内容发行", path: "/services#distribution" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="container-site py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="font-heading font-extrabold text-foreground-950 text-xl">芒</span>
              </span>
              <span className="font-heading font-bold text-xl text-background-50">芒果传媒</span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-300">
              专注于影视内容制作与传媒服务的综合型内容机构，用影像记录时代，用内容连接人心。
            </p>
            <div className="flex items-center gap-2.5 mt-5">
              {socialLinks.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  aria-label={s.name}
                  className="w-9 h-9 rounded-full bg-secondary-900 flex items-center justify-center text-secondary-200 hover:bg-primary-500 hover:text-foreground-950 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2.5">
              {navLinks.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              核心服务
            </h4>
            <ul className="flex flex-col gap-2.5">
              {serviceLinks.map((l) => (
                <li key={l.name}>
                  <Link
                    to={l.path}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              联系我们
            </h4>
            <ul className="flex flex-col gap-3 text-sm text-secondary-300">
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                <span className="leading-relaxed">{contactInfo.address}</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-phone-line text-primary-400"></i>
                <span>{contactInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-primary-400"></i>
                <span>{contactInfo.email}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-800/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            © 2026 芒果传媒 Mango Media. 保留所有权利。
          </p>
          <p className="text-xs text-secondary-400">
            沪ICP备 00000000 号 · 本站内容为品牌展示用途
          </p>
        </div>
      </div>
    </footer>
  );
}